import { render, staticRenderFns } from "./NormalSimpleButtonSmall.vue?vue&type=template&id=76e35ddd&scoped=true&"
import script from "./NormalSimpleButtonSmall.vue?vue&type=script&lang=js&"
export * from "./NormalSimpleButtonSmall.vue?vue&type=script&lang=js&"
import style0 from "./NormalSimpleButtonSmall.vue?vue&type=style&index=0&id=76e35ddd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e35ddd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
